// src/api/companyPolicyApi.ts
import api from './api';
import { CompanyPolicy } from '../types/companyPolicy';

const companyPolicyApi = {
  // List policies (backend scopes by branch; non-admins receive only published ones)
  getPolicies: async (category?: string) => {
    const response = await api.get('/company-policy/', {
      params: category ? { category } : undefined,
    });
    return response.data;
  },

  getPolicyById: async (id: string) => {
    const response = await api.get(`/company-policy/${id}`);
    return response.data;
  },

  // Admin-only on the backend (403 otherwise)
  createPolicy: async (data: Omit<CompanyPolicy, 'id'>) => {
    const response = await api.post('/company-policy/', data);
    return response.data;
  },

  updatePolicy: async (id: string, data: Partial<CompanyPolicy>) => {
    const response = await api.put(`/company-policy/${id}`, data);
    return response.data;
  },

  deletePolicy: async (id: string) => {
    const response = await api.delete(`/company-policy/${id}`);
    return response.data;
  },
};

export default companyPolicyApi;
